import LargeBanner from "./largeBanner";
import PromotionTip from "./promotionTip";
export default {
  LargeBanner,
  PromotionTip
};
